module.exports = __webpack_public_path__ + "img/49c7036.jpg";